/* src/app/layout/components/quick-panel/quick-panel.component.scss */
quick-panel {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 280px;
  min-width: 280px;
  max-width: 280px;
  z-index: 99;
}
quick-panel .mat-slide-toggle-content {
  flex: 1;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9sYXlvdXQvY29tcG9uZW50cy9xdWljay1wYW5lbC9xdWljay1wYW5lbC5jb21wb25lbnQuc2NzcyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsicXVpY2stcGFuZWwge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBmbGV4OiAxIDEgYXV0bztcbiAgICB3aWR0aDogMjgwcHg7XG4gICAgbWluLXdpZHRoOiAyODBweDtcbiAgICBtYXgtd2lkdGg6IDI4MHB4O1xuICAgIHotaW5kZXg6IDk5O1xuXG4gICAgLm1hdC1zbGlkZS10b2dnbGUtY29udGVudCB7XG4gICAgICAgIGZsZXg6IDE7XG4gICAgfVxufVxuIl0sCiAgIm1hcHBpbmdzIjogIjtBQUFBO0FBQ0ksV0FBQTtBQUNBLGtCQUFBO0FBQ0EsUUFBQSxFQUFBLEVBQUE7QUFDQSxTQUFBO0FBQ0EsYUFBQTtBQUNBLGFBQUE7QUFDQSxXQUFBOztBQUVBLFlBQUEsQ0FBQTtBQUNJLFFBQUE7OyIsCiAgIm5hbWVzIjogW10KfQo= */
